import { ON_SALES_CHART_ERROR_CHANGE } from '../actions.js';

const initialState = false;

export default (state = initialState, action) => {
  if (action.type === ON_SALES_CHART_ERROR_CHANGE) {
    return action.payload;
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/sales-chart-error.js